<div class="popup-title bg-active d-flex gap-2">
  <div>
    <div class="text-xl text-semi-bold">{{ event?.title }}</div>
    <div class="d-flex gap-2 align-items-center">
      <div class="badge badge-pill" [ngClass]="'badge-secondary-' + eventType?.color">{{ eventType?.name }}</div>
    </div>
  </div>
</div>

<div class="info-list mt-3">
  <div class="info-list-item">
    <div class="icon text-indigo">
      <i class="cs-icon cs-icon-calendar-plus text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>From</div>
      <div class="value">
        {{ event?.start | epochUTC : 'DD - MMM - YYYY' }}
      </div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-indigo">
      <i class="cs-icon cs-icon-calendar-plus text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>To</div>
      <div class="value">
        {{ event?.end | epochUTC : 'DD - MMM - YYYY' }}
      </div>
    </div>
  </div>
  <div class="info-list-item">
    <div class="icon text-success">
      <i class="cs-icon cs-icon-calendar text-xl"></i>
    </div>
    <div>
      <div class="label" i18n>Created On</div>
      <div class="value">
        {{ event?.created | epoch : 'datetime' }}
      </div>
    </div>
  </div>
</div>
